import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"

const CustomersForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const [formData, setFormData] = useState({
        full_name: '',
        contact_number: '',
        responsible_name: '',
        responsible_contact: ''
    })
    const {full_name, contact_number, responsible_name, responsible_contact} = formData

    const navigate = useNavigate()    

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const customerData = {full_name, contact_number, responsible_name, responsible_contact}
        addCustomer(customerData)
    }
    
    // add customer
    const addCustomer = async (customerData) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/customers/', customerData)
            if (response.status === 201){
                toast.success('Successfully created')
                navigate('/customers-serverside')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Create New Customer</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                            <InputField
                                placeholder="Customer Name"
                                name="full_name"
                                type="text"
                                label="Name"
                                value={full_name}
                                onChange={onChange}
                                error={errors.full_name}
                            />
                        </div>

                        <div className="col-md-3">
                        <InputField
                            placeholder="Customer Contact"
                            name="contact_number"
                            type="text"
                            label="Contact"
                            value={contact_number}
                            onChange={onChange}
                            error={errors.contact_number}
                        />
                        </div>

                        <div className="col-md-3">
                        <InputField
                            placeholder="Responsible Person Name"
                            name="responsible_name"
                            type="text"
                            label="Responsible Name"
                            value={responsible_name}
                            onChange={onChange}
                            error={errors.responsible_name}
                        />
                        </div>

                        <div className="col-md-3">
                        <InputField
                            placeholder="Responsible Contact Number"
                            name="responsible_contact"
                            type="text"
                            label="Responsible Contact"
                            value={responsible_contact}
                            onChange={onChange}
                            error={errors.responsible_contact}
                        />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Customer" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default CustomersForm
